import React from "react";
import Book from "./ui/Book";
import { books } from "../../data";

const Explore = () => {
  return (
    <section id="explore">
      <div className="container">
        <div className="row row__column">
          <h2 className="section__title">
            Explore more <span className="purple">Books</span>
          </h2>
          <a href="/books" className="btn">
            Browse all books
          </a>
          <div className="books">
            {books.slice(0, 8).map((book) => (
              <Book
                key={book.id}
                id={book.id}
                imgSrc={book.url}
                title={book.title}
                rating={book.rating}
                normalPrice={book.originalPrice}
                salePrice={book.salePrice}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore;
